import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { FreeFormImage } from "@/Patient/Api/Dto/Responses/FreeFormImage";
import { NoteStore } from "@/Patient/Stores/NoteStore";

class HandNoteHandler extends BaseOperationHandler {
    constructor() {
        super();

        this.RegisterOperation(LocalOperations.HandNote.LoadNoteForEdit, this.LoadNoteForEdit, true);
    }

    private LoadNoteForEdit(request: LocalEvent, store: NoteStore): void {
        var n = request.Get<FreeFormImage>("note");
        store.editNote = n;
    }
}

export { HandNoteHandler };
